var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { css } from '@emotion/react';
import { tokens } from '../tokens';
var decorVariantMap = {
    info: {
        color: tokens.colors.blue,
    },
    success: {
        color: tokens.colors.green,
    },
    warning: {
        color: tokens.colors.orangeLight,
    },
    error: {
        color: tokens.colors.red,
    },
    upgrade: {
        color: tokens.colors.purple,
    },
};
var invertedDecorVariantMap = __assign(__assign({}, decorVariantMap), { upgrade: {
        color: tokens.colors.purpleLight,
    } });
export function notificationStyle(_a) {
    var inverted = _a.inverted;
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    position: relative;\n    display: flex;\n    background-color: ", ";\n    border: ", " solid\n      ", ";\n    border-radius: ", ";\n    padding: 12px;\n  "], ["\n    position: relative;\n    display: flex;\n    background-color: ", ";\n    border: ", " solid\n      ", ";\n    border-radius: ", ";\n    padding: 12px;\n  "])), inverted ? tokens.colors.navy : tokens.colors.white, tokens.borderWidth.thin, inverted
        ? tokens.colors.transparentWhite
        : tokens.colors.transparentGrey, tokens.borderRadius.medium);
}
export function decorStyle(_a) {
    var variant = _a.variant, inverted = _a.inverted;
    var variantMap = inverted ? invertedDecorVariantMap : decorVariantMap;
    return css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    position: absolute;\n    z-index: ", ";\n    top: -1px;\n    left: -1px;\n    bottom: -1px;\n    width: 4px;\n    background-color: ", ";\n    border-top-left-radius: ", ";\n    border-bottom-left-radius: ", ";\n  "], ["\n    position: absolute;\n    z-index: ", ";\n    top: -1px;\n    left: -1px;\n    bottom: -1px;\n    width: 4px;\n    background-color: ", ";\n    border-top-left-radius: ", ";\n    border-bottom-left-radius: ", ";\n  "])), tokens.zIndex.default, variantMap[variant].color, tokens.borderRadius.medium, tokens.borderRadius.medium);
}
export function contentStyle(_a) {
    var closable = _a.closable, isContentCentered = _a.isContentCentered;
    return css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    ", "\n    padding-left: ", ";\n    align-self: center;\n\n    ", "\n  "], ["\n    ", "\n    padding-left: ", ";\n    align-self: center;\n\n    ", "\n  "])), closable && "padding-right: ".concat(tokens.spacing.small, ";"), tokens.spacing.small, !isContentCentered && css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n      flex-grow: 1;\n    "], ["\n      flex-grow: 1;\n    "]))));
}
export function closeButtonStyle(_a) {
    var inverted = _a.inverted;
    return css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    color: ", ";\n    flex-shrink: 0;\n    margin-left: auto;\n  "], ["\n    color: ", ";\n    flex-shrink: 0;\n    margin-left: auto;\n  "])), inverted ? tokens.colors.white : tokens.colors.navy);
}
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
